<template>
  <div class="welcome">
    <div>
      <img src="~@/assets/2021-WES-stack.png" alt class="logo" />
      <div>
        <iframe
          src="https://player.vimeo.com/video/456590417"
          width="640"
          height="360"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
        <div>
          <p>Place your deposit today for 2021 season tickets in Reserved Seating and The Bailey at West End Stadium.</p>
          <p>Current Season Ticket Members and the General Public can now make a $50 deposit to confirm your spot in the seat selection process for West End Stadium. Current Season Ticket Members will have priority over non season ticket members.</p>
          <p>Once your deposit is placed, you will be contacted by an FC Cincinnati ticket representative to talk through options and availability. Should you elect not to purchase season tickets, your $50 deposit can be applied to any partial plan or individual game tickets.</p>
          <p>We will soon share additional details on ticket limits, survey engagement, ticket options, and general good-to-knows. In the meantime, please feel free to take a tour of the stadium and seating options by entering below.</p>
          <button @click="$store.state.menu.showWelcome = false">
            <FCButton text="enter" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FCButton from "@/components/patterns/FCButton";
export default {
  components: {
    FCButton,
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.welcome {
  background: rgba(1, 9, 24, 0.9);

  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: DINNextLTPro-Regular;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 24px;
  overflow: auto;
  line-height: 1.2;
  a {
    color: #fff;
  }
  .bold {
    font-weight: bold;
  }
  > div {
    text-align: center;
    > img {
      margin-bottom: 1%;
      height: 184px;
    }
    > div {
      display: flex;
      text-align: left;
      justify-content: center;
      p:not(:last-of-type) {
        margin-bottom: 20px;
      }
      button {
        margin-top: 4vh;
        width: 100%;
      }
      > div {
        width: 38%;
      }
    }
  }
  iframe {
    width: 50%;
    margin-right: 7%;
  }
}
@media (max-width: 1100px) {
  .welcome {
    display: block;
    padding: 9%;
    min-height: 100vh;
    height: auto;
    max-height: 100vh;
    button {
      width: 100%;
      margin-bottom: 100px;
      > div {
        min-width: unset;
      }
    }
    > div {
      display: block;
      text-align: center;
      > div {
        display: block;
        width: 100%;
        > div {
          width: 100%;
          text-align: center;
          p {
            text-align: left;
          }
        }
        button {
          float: none;
        }
      }
      iframe {
        width: 100%;
        height: calc(0.5 * (100vw - 50px));
        margin: 0;
        margin-bottom: 15px;
      }
    }
  }
}
</style>